/* LÉER — Interactions et animations */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var ticking = false;
  var parallaxEls = [];
  var observer = null;

  function toArray(list) { return Array.prototype.slice.call(list); }

  /* ---------- Scroll : header, progression, parallaxe ---------- */
  function collectParallax() {
    parallaxEls = toArray(document.querySelectorAll('[data-parallax]'));
  }

  function onScroll() {
    var y = window.pageYOffset || root.scrollTop;
    if (document.body) document.body.classList.toggle('leer-scrolled', y > 40);
    var max = root.scrollHeight - window.innerHeight;
    root.style.setProperty('--leer-scroll', max > 0 ? (y / max).toFixed(4) : 0);

    if (!reduce) {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
        var offset = (r.top + r.height / 2 - vh / 2) * speed * -1;
        el.style.setProperty('--py', offset.toFixed(1) + 'px');
      });
    }
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }
  }

  /* ---------- Apparition au scroll ---------- */
  function initReveal(scope) {
    var els = toArray((scope || document).querySelectorAll('[data-reveal]:not(.is-in)'));
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Hero diaporama ---------- */
  function initHero(scope) {
    toArray((scope || document).querySelectorAll('[data-leer-hero]')).forEach(function (hero) {
      if (hero.getAttribute('data-ready')) return;
      hero.setAttribute('data-ready', '1');

      var slides = toArray(hero.querySelectorAll('.leer-hero__slide'));
      var dots = toArray(hero.querySelectorAll('.leer-hero__dot'));
      var delay = parseInt(hero.getAttribute('data-delay'), 10) || 6000;
      var index = 0;
      var timer = null;
      if (!slides.length) return;

      hero.style.setProperty('--dur', delay + 'ms');

      function schedule() {
        window.clearTimeout(timer);
        if (slides.length > 1 && !reduce && !designMode) {
          timer = window.setTimeout(function () { go(index + 1); }, delay);
        }
      }

      function go(n) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (n + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) {
          void dots[index].offsetWidth;
          dots[index].classList.add('is-active');
        }
        schedule();
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { if (i !== index) go(i); });
      });

      var startX = null;
      hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) go(dx < 0 ? index + 1 : index - 1);
        startX = null;
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) window.clearTimeout(timer); else schedule();
      });

      document.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target);
        if (i > -1 && i !== index) go(i);
      });

      schedule();
    });
  }

  /* ---------- Onglets + carrousel produits ---------- */
  function initTabs(scope) {
    toArray((scope || document).querySelectorAll('[data-leer-tabs]')).forEach(function (box) {
      if (box.getAttribute('data-ready')) return;
      box.setAttribute('data-ready', '1');

      var buttons = toArray(box.querySelectorAll('[data-tab]'));
      var panels = toArray(box.querySelectorAll('[data-panel]'));
      var links = toArray(box.querySelectorAll('[data-view-all]'));
      var prev = box.querySelector('[data-prev]');
      var next = box.querySelector('[data-next]');
      var bar = box.querySelector('[data-progress]');

      function activeRail() { return box.querySelector('[data-panel].is-active .leer-rail'); }

      function update() {
        var rail = activeRail();
        if (!rail) return;
        var max = rail.scrollWidth - rail.clientWidth;
        var progress = rail.scrollWidth > 0 ? (rail.scrollLeft + rail.clientWidth) / rail.scrollWidth : 1;
        if (bar) bar.style.setProperty('--p', Math.min(progress, 1).toFixed(3));
        if (prev) prev.disabled = rail.scrollLeft <= 4;
        if (next) next.disabled = rail.scrollLeft >= max - 4;
      }

      function step(direction) {
        var rail = activeRail();
        if (!rail) return;
        var item = rail.querySelector('.leer-rail__item');
        var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
        var width = item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
        rail.scrollBy({ left: direction * width, behavior: reduce ? 'auto' : 'smooth' });
      }

      function select(key) {
        buttons.forEach(function (b) {
          var on = b.getAttribute('data-tab') === key;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-panel') === key;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
        links.forEach(function (l) { l.hidden = l.getAttribute('data-view-all') !== key; });
        var rail = activeRail();
        if (rail) rail.scrollLeft = 0;
        update();
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () { select(b.getAttribute('data-tab')); });
      });
      panels.forEach(function (p) {
        var rail = p.querySelector('.leer-rail');
        if (rail) rail.addEventListener('scroll', update, { passive: true });
      });
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      window.addEventListener('resize', update);

      document.addEventListener('shopify:block:select', function (e) {
        var key = e.target.getAttribute && e.target.getAttribute('data-tab');
        if (key && box.contains(e.target)) select(key);
      });

      update();
    });
  }

  function init(scope) {
    collectParallax();
    initReveal(scope);
    initHero(scope);
    initTabs(scope);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
